module.exports = __webpack_public_path__ + "static/media/thigmophonic.35c62d6c.jpg";